module.exports = __webpack_public_path__ + "static/media/icon-1.eb66acb3.png";